import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import cs from './locales/cs.json'
import pl from './locales/pl.json'

const detectInitialLang = (): "cs" | "pl" | "en" => {
    const stored = localStorage.getItem('lang')
    if (stored === "cs" || stored === "pl" || stored === "en") return stored
    if (typeof navigator !== "undefined") {
        const lang = navigator.language?.toLowerCase() ?? ""
        if (lang.startsWith("cs") || lang.startsWith("sk")) return "cs"
        if (lang.startsWith("pl")) return "pl"
    }
    return "en"
}

i18n.use(initReactI18next).init({
    lng: detectInitialLang(),
    fallbackLng: 'en',
    resources: {
        en: { translation: en },
        cs: { translation: cs },
        pl: { translation: pl },
    },
    interpolation: { escapeValue: false },
})

export default i18n
